import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Award = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = '#9759CC', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 25 25"
      fill="none"
      {...rest}
    >
      <path
        d="M5.19287 11.5199V16.4899C5.19287 18.3099 5.19287 18.3099 6.91287 19.4699L11.6429 22.1999C12.3529 22.6099 13.5129 22.6099 14.2229 22.1999L18.9529 19.4699C20.6729 18.3099 20.6729 18.3099 20.6729 16.4899V11.5199C20.6729 9.69994 20.6729 9.69994 18.9529 8.53994L14.2229 5.80994C13.5129 5.39994 12.3529 5.39994 11.6429 5.80994L6.91287 8.53994C5.19287 9.69994 5.19287 9.69994 5.19287 11.5199Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M18.4331 8.13V5.5C18.4331 3.5 17.4331 2.5 15.4331 2.5H10.4331C8.43311 2.5 7.43311 3.5 7.43311 5.5V8.06"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M13.5629 11.49L14.1329 12.38C14.2229 12.52 14.4229 12.66 14.5729 12.7L15.5929 12.96C16.2229 13.12 16.3929 13.66 15.9829 14.16L15.3129 14.97C15.2129 15.1 15.1329 15.33 15.1429 15.49L15.2029 16.54C15.2429 17.19 14.7829 17.52 14.1829 17.28L13.2029 16.89C13.0529 16.83 12.8029 16.83 12.6529 16.89L11.6729 17.28C11.0729 17.52 10.6129 17.18 10.6529 16.54L10.7129 15.49C10.7229 15.33 10.6429 15.09 10.5429 14.97L9.87289 14.16C9.46289 13.66 9.63289 13.12 10.2629 12.96L11.2829 12.7C11.4429 12.66 11.6429 12.51 11.7229 12.38L12.2929 11.49C12.6529 10.95 13.2129 10.95 13.5629 11.49Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Award.displayName = 'Award';
